import { render, staticRenderFns } from "./SingleChoiceForm.vue?vue&type=template&id=567f098a&scoped=true"
import script from "./SingleChoiceForm.vue?vue&type=script&lang=js"
export * from "./SingleChoiceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567f098a",
  null
  
)

export default component.exports